/* donut-label.tsx generated by @compiled/babel-plugin v0.28.8 */
import { ax, ix, CC, CS } from "@compiled/react/runtime";
import { element } from '../../../core/elements';
import Group from '../../../primitives/shape/Group';
import Text from '../../../primitives/text/Text';
import formatters from '../../../primitives/utils/formatters';
import { jsxs as _jsxs, jsx as _jsx } from "react/jsx-runtime";
const _6 = "._1wyb7vkz{font-size:1pc}";
const _5 = "._lswu1jij{fill:var(--ds-text-subtlest)}";
const _4 = "._1wyb1pa9{font-size:29px}";
const _3 = "._ect41wi2{font-family:-apple-system,BlinkMacSystemFont,\"Segoe UI\",\"Roboto\",\"Oxygen\",\"Ubuntu\",\"Fira Sans\",\"Droid Sans\",\"Helvetica Neue\",sans-serif}";
const _2 = "._1fjgnkob{text-anchor:middle}";
const _ = "._lswu1blv{fill:var(--ds-text)}";
export const donutValueStyles = null;
export const donutLabelStyles = null;
export const DonutMetricValue = element(_ref => {
  let {
    totalValue,
    width,
    formatter
  } = _ref;
  return /*#__PURE__*/_jsxs(CC, {
    children: [/*#__PURE__*/_jsx(CS, {
      children: [_, _2, _3, _4]
    }), /*#__PURE__*/_jsx(Text, {
      width: width,
      truncate: true,
      className: ax(["_lswu1blv _1fjgnkob _ect41wi2 _1wyb1pa9"]),
      children: formatter(totalValue)
    }, `donut-value-${totalValue}`)]
  }, `donut-value-${totalValue}`);
});
export const DonutMetricLabel = element(_ref2 => {
  let {
    totalValue,
    width,
    label
  } = _ref2;
  return /*#__PURE__*/_jsxs(CC, {
    children: [/*#__PURE__*/_jsx(CS, {
      children: [_5, _2, _3, _6]
    }), /*#__PURE__*/_jsx(Text, {
      y: 24,
      width: width,
      truncate: true,
      className: ax(["_lswu1jij _1fjgnkob _ect41wi2 _1wyb7vkz"]),
      children: label
    }, `donut-value-text-${totalValue}`)]
  }, `donut-value-text-${totalValue}`);
});
export const DonutMetric = element(function DonutLabel(_ref3) {
  let {
    data,
    hide,
    valueAccessor,
    innerRadius
  } = _ref3;
  if (hide) return null;
  if (innerRadius < 30) return null;
  const centerTextValue = data.reduce((total, d) => total + valueAccessor(d), 0);

  /* Approximating truncation width, for text to fit in the biggest square inside the inner circle. */
  const width = innerRadius * Math.SQRT2;
  return /*#__PURE__*/_jsxs(Group, {
    children: [/*#__PURE__*/_jsx(DonutMetricValue, {
      width: width,
      totalValue: centerTextValue,
      formatter: formatters.formatNumberAbbreviated
    }), /*#__PURE__*/_jsx(DonutMetricLabel, {
      width: width,
      label: 'Total value',
      totalValue: centerTextValue
    })]
  });
});